import { Routes } from '@angular/router'
import { AppRoute } from './app.routes.fixtures'
import { AdminGuard } from './guards/admin.guard'
import { AuthGuard } from './guards/auth.guard'
import { HomeGuard } from './guards/home.guard'
import { IntroGuard } from './guards/intro.guard'

export const routes: Routes = [
  {
    path: '',
    redirectTo: AppRoute.intro,
    pathMatch: 'full',
  },
  {
    path: AppRoute.intro,
    loadComponent: () =>
      import('./pages/intro/intro.page').then((m) => m.IntroPage),
    canActivate: [IntroGuard],
  },
  {
    path: AppRoute.backToIntro,
    loadComponent: () =>
      import('./pages/intro/intro.page').then((m) => m.IntroPage),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.welcomeOrientation,
    loadComponent: () =>
      import('./pages/welcome-orientation/welcome-orientation.page').then(
        (m) => m.WelcomeOrientationPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.home,
    loadChildren: () =>
      import('./pages/home/home-tabs/home-tabs.routes').then(
        (m) => m.homeTabRoutes
      ),
    canActivate: [AuthGuard, HomeGuard],
  },
  {
    path: AppRoute.homeTabs,
    loadChildren: () =>
      import('./pages/home/home-tabs/home-tabs.routes').then(
        (m) => m.homeTabRoutes
      ),
    canActivate: [AuthGuard, HomeGuard],
  },
  {
    path: AppRoute.homeMenu,
    loadChildren: () =>
      import('./pages/home/home-menu/home-menu.routes').then(
        (m) => m.homeMenuRoutes
      ),
    canActivate: [AuthGuard, HomeGuard],
  },
  {
    path: AppRoute.admin,
    loadChildren: () =>
      import('./pages/administration/admin.routes').then((m) => m.adminRoutes),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: AppRoute.userProfileWizard,
    loadComponent: () =>
      import('./pages/user-profile-wizard/user-profile-wizard.page').then(
        (m) => m.UserProfileWizardPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.universityDetails,
    loadComponent: () =>
      import('./pages/details/university-details/university-details.page').then(
        (m) => m.UniversityDetailsPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.departmentDetails,
    loadComponent: () =>
      import('./pages/details/department-details/department-details.page').then(
        (m) => m.DepartmentDetailsPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.chat,
    loadComponent: () =>
      import('./pages/chat/chat.page').then((m) => m.ChatPage),
    canActivate: [AuthGuard],
  },
  {
    path: `${AppRoute.chat}/:chatRoomId`,
    loadComponent: () =>
      import('./pages/chat/chat.page').then((m) => m.ChatPage),
    canActivate: [AuthGuard],
  },
  {
    path: AppRoute.licenses,
    loadComponent: () =>
      import('./pages/settings/licenses/licenses.page').then(
        (m) => m.LicensesPage
      ),
  },
  {
    path: AppRoute.support,
    loadComponent: () =>
      import('./pages/settings/support/support.page').then(
        (m) => m.SupportPage
      ),
  },
  {
    path: AppRoute.dataPrivacy,
    loadComponent: () =>
      import('./pages/settings/data-privacy/data-privacy.page').then(
        (m) => m.DataPrivacyPage
      ),
  },
  {
    path: AppRoute.imprint,
    loadComponent: () =>
      import('./pages/settings/imprint/imprint.page').then(
        (m) => m.ImprintPage
      ),
  },
  {
    path: AppRoute.notFound,
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found.page').then(
        (m) => m.PageNotFoundPage
      ),
  },
  {
    path: AppRoute.deleteAccount,
    loadComponent: () =>
      import('./pages/delete-account/delete-account.page').then(
        (m) => m.DeleteAccountPage
      ),
  },
  {
    path: '**',
    redirectTo: AppRoute.notFound,
    pathMatch: 'full',
  },
]
